webpackJsonp([3],{

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(23);

var _styledComponents = __webpack_require__(47);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import pixelaGraph from '../../public/photo-shoots.svg'

var AboutStyles = _styledComponents2.default.div.withConfig({
  displayName: 'About__AboutStyles',
  componentId: 'mv6a3f-0'
})(['.profile_image{max-width:300px;width:50%;}p{margin:2rem 0;}ul{margin:2rem 0;padding-left:1.1rem;li{padding:.3rem 0;}}h3{margin-bottom:.5rem;}.pixela{max-width:400px;background:white;}']);

exports.default = function () {
  return _react2.default.createElement(
    AboutStyles,
    null,
    _react2.default.createElement(_reactStatic.Head, {
      title: 'about',
      meta: [{ name: "description", content: 'it\'s my portfolio website. my information is here' }, { property: "og:title", content: "about | Ryoji Hayasaka Portfolio" }, { property: "og:description", content: 'it\'s my portfolio website. my information is here' }, { property: "og:image", content: "https://secure.gravatar.com/avatar/301071becdd1890fa7078cbe29ce83ba?s=400" }, { property: "og:url", content: 'https://hyks.jp/about' }, { property: "og:type", content: "article" }]
    }),
    _react2.default.createElement(
      'h1',
      null,
      'about'
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('img', { className: 'profile_image', alt: 'my portrait', decoding: 'async', src: 'https://secure.gravatar.com/avatar/301071becdd1890fa7078cbe29ce83ba?s=400' })
    ),
    _react2.default.createElement(
      'p',
      null,
      'Living in japan as a programmer, or a photographer.'
    ),
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactStatic.Link,
          { to: 'https://twitter.com/r_hayakasa' },
          'Twitter'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactStatic.Link,
          { to: 'https://facebook.com/hayakasa' },
          'Facebook'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactStatic.Link,
          { to: 'http://tumblr.hyks.jp' },
          'tumblr'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactStatic.Link,
          { to: 'https://github.com/hayakasa' },
          'GitHub'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactStatic.Link,
          { to: 'https://instagram.com/hayakasa' },
          'Instagram'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactStatic.Link,
          { to: 'https://unsplash.com/@hayakasa' },
          'Unsplash'
        )
      ),
      _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _reactStatic.Link,
          { to: 'https://500px.com/ryojihayasaka' },
          '500px'
        )
      )
    ),
    _react2.default.createElement(
      'h3',
      null,
      'my photo shoot counts'
    ),
    _react2.default.createElement('object', { className: 'pixela', type: 'image/svg+xml', data: 'https://pixe.la/v1/users/hayakasa/graphs/photo-shoots' })
  );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/About.f608d5e8.js